import { RATES_ACTIONS } from 'store/v1/rates/rates.constants.js';

export const INITIAL_STATE = {
  data: {},
  paging: {},
  order: [],
  loading: false,
  fetched: false
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case RATES_ACTIONS.GET_RATES:
    case RATES_ACTIONS.CREATE_RATE:
    case RATES_ACTIONS.UPDATE_RATE:
    case RATES_ACTIONS.DELETE_RATE:
      return {
        ...state,
        loading: action.type,
        error: false
      };
    case RATES_ACTIONS.GET_RATES_SUCCESS:
      return {
        ...state,
        data: action.result.results.reduce(
          (data, item) => ({ ...data, [item.id]: item }),
          {}
        ),
        order: action.result.results.map(item => item.id),
        paging: action.result.paging,
        loading: false,
        fetched: true
      };
    case RATES_ACTIONS.UPDATE_RATE_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          [action.result.id]: action.result
        },
        loading: false
      };
    case RATES_ACTIONS.CREATE_RATE_SUCCESS:
      return {
        ...state,
        data: { ...state.data, [action.result.id]: action.result },
        order: [...state.order, action.result.id],
        loading: false
      };
    case RATES_ACTIONS.DELETE_RATE_SUCCESS:
      const { [action.rate_id]: item, ...data } = state.data;
      return {
        ...state,
        data,
        order: state.order.filter(id => id !== action.rate_id),
        loading: false
      };
    case RATES_ACTIONS.GET_RATES_FAILURE:
    case RATES_ACTIONS.UPDATE_RATE_FAILURE:
    case RATES_ACTIONS.CREATE_RATE_FAILURE:
    case RATES_ACTIONS.DELETE_RATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
}
